import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import { withRouter } from 'react-router';
import SignIn from './SignIn';

import logo from '../images/XNS.svg';

const MenuSlider = () => <div className="menu-slider" />;

class HeaderMenu extends Component {
    state = {
        collapsed: false
    };

    componentDidMount() {
        this.updateMenuSlider();
        window.addEventListener('resize', this.debounce(this.updateMenuSlider));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.debounce(this.updateMenuSlider));
    }

    debounce(func, timeout = 50) {
        let timer;
        return (...args) => {
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(() => func.apply(this, args), timeout);
        };
    }

    async updateMenuSlider() {
        // Wait some time for browser to finish rendering after a minimize/maximize.
        await new Promise(resolve => setTimeout(resolve, 100));

        let menuSlider = document.querySelector(".menu-slider");
        let selectedMenuItem = document.querySelector(".ant-menu-item-selected");

        // Guard: selectedMenuItem may be null if no menu item is selected
        if (!selectedMenuItem) {
            if (menuSlider) {
                menuSlider.style.opacity = 0;
            }
            return;
        }

        let opacity = window.getComputedStyle(selectedMenuItem).getPropertyValue("opacity");

        if (opacity <= 0) {
            menuSlider.style.opacity = 0;
        } else {
            menuSlider.style.opacity = 1;
            menuSlider.style.left = selectedMenuItem.offsetLeft + "px";
            menuSlider.style.width = selectedMenuItem.getBoundingClientRect().width + "px";
        }
    }

    render() {
        return (
            <div id="sidemenu">
                <div className="logo-box">
                    <div className="logo">
                        <img src={logo} alt="XN1" />
                    </div>
                    <SignIn
                        signInVisible={!localStorage.getItem('user')}
                        closeSignIn={() => this.setState({ signInVisible: false })}
                    />
                </div>

                <Menu
                    theme="dark"
                    mode="horizontal"
                    selectedKeys={
                        this.props.location.pathname === '' || this.props.location.pathname === '/'
                            ? ['/']
                            : (this.props.location.pathname.startsWith('/wizard')
                                ? ['/testplans']
                                : [this.props.location.pathname.replace(/\/$/, '')])
                    }
                    defaultOpenKeys={this.props.location.pathname.split('/').filter((a) => a)}
                >
                    <MenuSlider />

                    <Menu.Item key="/" onClick={this.updateMenuSlider}>
                        STATIONS
                        <Link to="/" />
                    </Menu.Item>

                    <Menu.Item key="/testplans" className="modified-item" onClick={this.updateMenuSlider}>
                        TEST PLAN BUILDER
                        <Link to="/testplans" />
                    </Menu.Item>

                    <Menu.Item key="/database" onClick={this.updateMenuSlider}>
                        DATA BROWSER
                        <Link to="/database" />
                    </Menu.Item>

                    <Menu.Item key="/settings" onClick={this.updateMenuSlider}>
                        SETTINGS
                        <Link to="/settings" />
                    </Menu.Item>

                    {this.props.advance && (
                        <Menu.Item key="/logs" onClick={this.updateMenuSlider}>
                            Logs
                            <Link to="/logs" />
                        </Menu.Item>
                    )}

                    <Menu.Item key="/about" onClick={this.updateMenuSlider}>
                        ABOUT
                        <Link to="/about" />
                    </Menu.Item>
                </Menu>

                <div className="jgr-logo">
                    <a href="https://inst.santec.com" target="_blank" rel="noopener noreferrer">
                        <img src="/images/santec_logo_stacked_white.svg" alt="watermark" />
                    </a>
                </div>
            </div>
        );
    }
}

export default withRouter(HeaderMenu);
